module.exports = __webpack_public_path__ + "img/20191021162953388.c1bdb363.jpg";